import React from 'react';
//material
import {withStyles, Avatar} from '@material-ui/core';
//styles
import styles from './avatar-styles';

const AvatarView = (props) => {
  const {classes, size, src, alt, className} = props;

  return (
    <div className={className + ' ' + classes.avatarContent}>
      <div
        style={{height: size, width: size, borderRadius: size / 2}}
        className={classes.avatarBackground}>
        <Avatar
          className={classes.avatar}
          style={{height: size - 6, width: size - 6}}
          src={src}
          alt={alt} />
      </div>
    </div>
  );
};

export default withStyles(styles) (AvatarView);
